module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_1.bc86a26a.png";